import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { SystemRole } from '../../../Enums/system-role.enum';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const minRole = route.data['minRole'] as SystemRole | undefined;

  return authService.initializeAuth().pipe(
    map((is_authenticated) => {
      if (!is_authenticated) {
        authService.setReturnUrl(state.url);

        return router.createUrlTree(['/auth/login']);
      }

      const operator = authService.getCurrentOperator();

      if (!operator?.system_role) {
        authService.clearAuth();

        return router.createUrlTree(['/auth/login']);
      }

      if (minRole && !operator.atLeast(minRole)) {
        return router.createUrlTree(['/']);
      }

      return true;
    }),
  );
};
